module.exports = __webpack_public_path__ + "static/media/4.316972cf.png";